import { render, staticRenderFns } from "./Superscript.vue?vue&type=template&id=59968862&"
import script from "./Superscript.vue?vue&type=script&lang=js&"
export * from "./Superscript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports